/**
 * @description: 存放知识库 URL searchParam key
 */

// // 块引用
export const blockIdKey = 'block_id';

const document = {
    mentionId: 'mentionId',
    mentionVersion: 'mentionVersion',
    isNewDoc: 'isNewDoc',
    editor: 'editor',
    'block_id': 'block_id',
    bottomCommentId: 'bottomCommentId',
    rightCommentId: 'rightCommentId',
    onlineTodoId: 'onlineTodoId',
    tb: 'tb',
    type: 'type',
    id: 'id',
    aiChatShow: 'aiChatShow',
    editionId: 'editionId',
    // 用来blockId不存在时的特殊处理文案，卡片点赞
    blockIdFrom: 'from',
    rlNotice: 'rlNotice',
};

const search = {
    date: 'date',
    type: 'type',
    authority: 'authority',
    match: 'match',
    page: 'page',
    query: 'query',
    isOpenPublic: 'isOpenPublic',
};
const user = {
    scrollToBottom: 'scrollToBottom',
};

const space = {
    followed: 'followed',
    newCreate: 'newCreate',
    from: 'from',
    depShowWeekData: 'depShowWeekData',
    token: 'token',
    action: 'action',
    lang: 'lang',
    source: 'source',
    edit: 'edit',
    searchUserGuid: 'searchUserGuid',
};

// 客户端专用search
const client = {
    chatId: 'chatId',
    fid: 'fid',
    chatType: 'chatType',
    importType: 'importType',
    fileName: 'fileName',
    spaceGuid: 'spaceGuid',
    groupGuid: 'groupGuid',
    repositoryGuid: 'repositoryGuid',
    parentGuid: 'parentGuid',
};

const login = {
    ticket: 'ticket',
    service: 'service',
    renew: 'renew',
    appKey: 'appKey',
    version: 'version',
    // 用于对外知识库，passport登陆
    stoken: 'stoken',
};

// 专属于ku享
const kuShare = {
    clientKuShareNew: 'clientKuShareNew',
};

const queryView = {
    view: 'view',
    viewmode: 'viewmode',
};

const sdk = {
    v: 'v',
    path: 'path',
    domain: 'domain',
    bridgeId: 'bridgeId',
};

const flex = {
    builders: 'builders',
};

const KU_QUERY = {
    document,
    user,
    search,
    space,
    // 除了document/user/space的searchParams，如果您觉得还有没被清晰归类的请放到common下划分模块
    common: {
        client,
        login,
        kuShare,
    },
    sdk,
    queryView,
    flex,
};
const whiteList = ['type'];
const arrKey: string[] = [];
const arrVal: string[] = [];
const checkDuplicateQuerys = (obj: any) => {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const val = obj[key];
            if (typeof val === 'object') {
                checkDuplicateQuerys(val);
            } else {
                const findRepeat = arrKey.includes(key) || arrVal.includes(val);
                // 由于type字段重复，但是已经在使用，修改后怕影响分享出去的链接，先做白名单
                const findWhiteList = whiteList.includes(key) || whiteList.includes(val);
                if (findRepeat && !findWhiteList) {
                    console.warn(`KU_QUERY配置表中的 ${key} 字段重复设置，请在@/constants/common/searchParamKeys中检查`);
                }
                arrKey.push(key);
                arrVal.push(val);
            }
        }
    }
};
checkDuplicateQuerys(KU_QUERY);


export default KU_QUERY;
